// Tells the server about errors in the browser (observe.py keeps them with who hit them), so a crash someone
// mentions later can be found: the error screen's render errors and any uncaught error or rejection.

type Kind = "render" | "error" | "rejection";

const sent = new Set<string>();
const MAX_PER_PAGE = 20;

/** The bundle this page runs, so a report can be matched to the deploy that served it. */
function build(): string {
  const script = document.querySelector<HTMLScriptElement>('script[type="module"][src*="/assets/"]');
  return script ? script.src.split("/").pop() ?? "" : "";
}

export function reportError(kind: Kind, error: unknown): void {
  const e = error instanceof Error ? error : new Error(typeof error === "string" ? error : JSON.stringify(error) ?? "Unknown error");
  const message = (e.message || e.name || "Unknown error").slice(0, 2000);
  const stack = (e.stack ?? "").slice(0, 20000);
  const key = `${kind}|${message}|${stack.slice(0, 300)}`;
  if (sent.has(key) || sent.size >= MAX_PER_PAGE) return;
  sent.add(key);
  // keepalive: the report still goes if the person reloads or leaves right away.
  void fetch("/api/client-errors", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ kind, message, stack, url: location.href.slice(0, 2000), build: build() }),
    credentials: "same-origin",
    keepalive: true,
  }).catch(() => {});
}

/** Once, at startup: errors no component caught. */
export function reportUncaught(): void {
  window.addEventListener("error", (event) => {
    // A failed image or script load fires here too, without an error object; those aren't crashes.
    if (event.error) reportError("error", event.error);
  });
  window.addEventListener("unhandledrejection", (event) => reportError("rejection", event.reason));
}
